import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";

const HeadSection = ({ widths, alignmentHorizontal, type, children }) => {
  return (
    <Row
      minWidth={390}
      alignmentHorizontal={alignmentHorizontal}
      widths={widths}
      backgroundColor="#FFE5CB"
    >
      <Column></Column>
      <Text type={type ?? "h500"} fontFamily={"bookerly"}>
        {children}
      </Text>
    </Row>
  );
};

export default HeadSection;
